import { useState, useRef, useEffect, useContext, createContext } from "react";
import { usePrinters } from "./PrintersContext";

interface PrinterWebSocketContextProps {
  isReady: boolean,
  value: string | null,
  commandExecutedId: number,
  setCommandExecutedId: (value: number) => void,
  send: (command: string, id: number) => Promise<void>,
  setIPAddress: (ip: string) => void
}

const PrinterWebSocketContext = createContext(
  { isReady: false, value: "", send: (command: string) => { }, setIPAddress: (ip: string) => { } } as PrinterWebSocketContextProps)

const WebSocketProvider = ({ children }: { children: React.ReactNode }) => {
  const [isReady, setIsReady] = useState(false)
  const [value, setValue] = useState<string | null>(null)
  const [commandExecutedId, setCommandExecutedId] = useState<number>(0)

  const [printerIPAddress, setPrinterIPAddress] = useState(localStorage.getItem("@FixitApp:printerIP") || "")

  const ws = useRef<WebSocket | null>(null)

  const { setDefaultPrinter, defaultPrinter } = usePrinters()

  useEffect(() => {
    if (!printerIPAddress) {
      setIsReady(false)
      return
    }

    setIsReady(true)

    defaultPrinter &&
      setDefaultPrinter(
        {
          ...defaultPrinter,
          ipConnected: true
        }
      )

  }, [defaultPrinter, printerIPAddress])

  const contextValues = {
    isReady,
    value,
    commandExecutedId,
    setCommandExecutedId,
    send: (command: string, id: number): Promise<void> => {
      if (ws.current) {
        const formattedCommandforRPC =
          JSON.stringify({
            jsonrpc: "2.0",
            method: "printer.gcode.script",
            params: {
              script: `${command}`
            },
            id: id
          });

        console.log(formattedCommandforRPC)
        ws.current!.send(formattedCommandforRPC);
      }

      return Promise.resolve();
    },
    setIPAddress: (ip: string) => {
      setPrinterIPAddress(ip)
    }
  }


  return (
    <PrinterWebSocketContext.Provider value={contextValues}>
      {children}
    </PrinterWebSocketContext.Provider>
  )
};

function useWebSocket() {
  const context = useContext(PrinterWebSocketContext);

  if (!context) {
    throw new Error("useWebSocket must be used within an AuthProvider");
  }

  return context;
}

export { useWebSocket, WebSocketProvider };
